import { SellerInitializationStoreSlice } from './types';
import { reduxKey } from './constants';

function getState(state: any): SellerInitializationStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export function getInitializationRequestStatus(state: any) {
  return getState(state).requestStatus;
}

export function getInitializationRequestError(state: any) {
  return getState(state).requestError;
}

export function getIsInitialized(state: any) {
  return getState(state).isInitialized;
}

export function getExtraDeviationData(state: any): SellerInitializationStoreSlice['deviationData'] {
  return getState(state).deviationData;
}

export function getExtraDeviationDataById(state: any, deviationId: number) {
  return getExtraDeviationData(state)[deviationId];
}
